export const textConfig = {
  flowTitle: 'we provide quality service',
  mainTitle: 'Search Any Movies and Review it as much as you want',
  subTitle:
    'Discover the world of indulgent review, not just nearly indulgent review, but really indulgent review.',
};

export const glassesConfig = {
  initial: {
    x: 2000,
    y: 600,
  },
  animate: {
    x: 1350,
    y: 600,
    rotate: 30,
  },
  transition: {
    delay: 0.2,
  },
  alt: 'Mr.3D',
  width: 150,
};

export const popcornConfig = {
  initial: {
    x: -300,
    y: 200,
  },
  animate: {
    x: 200,
    y: 200,
    rotate: -30,
  },
  transition: {
    delay: 0.1,
  },
  alt: 'Mr.Popcorn',
  width: 200,
};
